export default "__VITE_ASSET__92e7fa65__"